import { ListenableSubscribable } from '@benzinga/subscribable';

export interface UserStoreEvent {
  type: 'user:updated_global_settings';
  globalSettings: object;
}

export class UserStore extends ListenableSubscribable<UserStoreEvent> {
  private date?: Date;
  private globalSettings?: object;

  public shouldUpdateGlobalSettings = (): boolean => {
    const ONE_MIN = 60 * 1000; /* ms */
    const lastCalled = this.date?.getTime() ?? 0; // use this once all watchlist are grabbed from manager
    if (this.globalSettings === undefined || Date.now() - lastCalled > ONE_MIN) {
      return true;
    }
    return false;
  };

  public setGlobalSettings = (globalSettings: object): void => {
    this.date = new Date();
    this.globalSettings = globalSettings;
    this.dispatch({
      globalSettings: this.globalSettings,
      type: 'user:updated_global_settings',
    });
  };

  public getGlobalSettings = (): object | undefined => {
    return this.globalSettings;
  };
}
